const MuiDatePicker = {
  defaultProps: {
    disableFuture: true,
    inputFormat: 'dd/MM/yyyy',
  },
}

export default MuiDatePicker
